module.exports = __webpack_public_path__ + "static/media/hangCall.da672302.png";